import * as React from 'react'
import { Row, Col, Button } from 'reactstrap';
import { useHistory } from 'react-router';
import { BeatLoader } from 'react-spinners';
import { toastr } from 'react-redux-toastr';
import { useAuth } from 'src/modules/Auth/hooks/useAuth';
import { UserTypes } from 'src/modules/Auth/store/types';
import ConfirmationModal from 'src/share/components/ConfirmationModal/ConfirmationModal';
import { HelpService } from 'src/share/services/help';

function HelpCategory(props) {
  const history = useHistory();
  const [auth] = useAuth();
  const [category, setCategory] = React.useState<any>();
  const [isLoading, setIsLoading] = React.useState(false);
  const [isModalToggled, setIsModalToggled] = React.useState(false);
  const isAdmin = auth.userType === UserTypes.ADMIN;
  React.useEffect(() => {
    const newCategory = props.location.state && props.location.state.category;
    if(newCategory) {
      setCategory(newCategory);
      return;
    }
    fetchData();
  }, []);
  async function fetchData() {
    try {
      setIsLoading(true);
      const categoryId = props.match.params.categoryId;
      const newCategory = await HelpService.getCategoryById(categoryId);
      if (newCategory) {
        setCategory(newCategory);
        setIsLoading(false);
      } else {
        history.push('/help');
        toastr.error('There was a problem loading the category');
      }
    } catch {
      toastr.error('Error', 'There was a problem connecting to the server');
      setIsLoading(false);
    }
  }
  async function handleCategoryDeleted() {
    try {
      setIsLoading(true);
      const { categoryId } = category;
      await HelpService.deleteCategoryById(categoryId);
      setTimeout(() => history.push(`/help`), 2000);
    } catch (error) {
      history.push('/help');
      toastr.error('There was a problem', 'The article could not be deleted');
    }
  }
  return (
    <div className="help-center__category">
      {!isLoading && category &&
        <div className="white-background help-content">
          <Row>
            <Col className="col-md-12">
              <div className="article-view-nav">
                <h2 onClick={() => history.push('/help')}>Support</h2>
                <h2 className="separator">&gt;</h2>
                <h2>{category.title}</h2>
              </div>
            </Col>
          </Row>
          <Col className="col-md-12">
            <Row>
              <Col className="col-md-6">
                <h2>{category.title}{category.articles.length > 0 && <span className="help-articles-counter">{` (${category.articles.length})`}</span>}</h2>
                <ul>
                  {category.articles.map(article => (
                    <li key={article.articleId} onClick={() => history.push(`/help/article/${category.title}/${category.categoryId}/${article.articleId}`)}>
                      <h3>{article.title}</h3>
                    </li>
                  ))}
                  {isAdmin && 
                    <li className="help-add-article" onClick={() => history.push(`/help/form/${category.title}/${category.categoryId}`)}>
                      Add new article
                    </li>
                  }
                </ul>
              </Col>
            </Row>
          </Col>
          <Row>
            <Col className="col-md-12">
              {isAdmin &&
                <Button className="btn float-right btn-grey-fill btn-help" onClick={() => setIsModalToggled(prevIsModalToggled => !prevIsModalToggled)}>
                  Delete
                </Button>}
            </Col>
          </Row>
        </div>}
      <div className="help-loader">
        <BeatLoader loading={isLoading} />
      </div>
      <ConfirmationModal
        isOpen={isModalToggled}
        toggle={() => setIsModalToggled(prevIsModalToggled => !prevIsModalToggled)}
        title={'Delete category'}
        description={isLoading ? 'Deleting category...' : 'Do you want to delete this category?'}
        loading={isLoading}
        showButtons={!isLoading}
        onContinue={handleCategoryDeleted}
      />
    </div>
  )
}

export default React.memo(HelpCategory);



// WEBPACK FOOTER //
// ./src/modules/UserSettings/Help/Category/HelpCategory.tsx